module.exports = vendor_ffe0ba77b3870c87489a;


//////////////////
// WEBPACK FOOTER
// external "vendor_ffe0ba77b3870c87489a"
// module id = 58
// module chunks = 0